<template>
	<div class="programme">
		<div class="nav">
			<van-icon name="arrow-left" color="#fff" size="1.1rem" @click="back" />
			<span>我的方案</span>
			<div></div>
		</div>
		<div class="center">
			<van-cell title="方案1" is-link to="/compomtnes" />
			<van-cell title="方案2" is-link  />
			<van-cell title="方案3" is-link  />
			<van-cell title="方案4" is-link  />
		</div>
		<div class="btn">
			<button @click="dakai">创建产品方案模板</button>
		</div>
		<van-popup v-model="show" round>
			<div class="block">
				<div>请输入方案名称</div>
				<van-cell-group>
					<van-field v-model="value" placeholder="请输入方案名称" />
				</van-cell-group>
				<div class="btn" style="margin-top: 20px; padding-bottom: 0;">
					<button @click="chaungjian">确定</button>
				</div>
			</div>
		</van-popup>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				show: false,
				value: '',
			}
		},
		created() {

		},
		methods: {
			dakai() {
				this.show = true;
			},
			chaungjian() {
				console.log(this.value)
			}
		}
	}
</script>
<style scoped>
	.programme {
		text-align: left;
		background: #fcfcfc;
		padding-top: 2rem;
	}

	.programme .van-cell {
		font-size: 0.8rem;
	}

	.programme .van-cell .van-cell__value {
		display: flex;
		align-items: center;
		justify-content: flex-end;
	}

	.programme .top,
	.center,
	.bottom {
		box-shadow: 1px 1px 5px #eee;
	}

	.programme .top .icon {
		align-items: center;
	}

	.programme .top img {
		width: 3rem;
		height: 3rem;
		border-radius: 50%;
		object-fit: cover;
	}

	.programme .center {
		margin: 1rem 0;
	}

	.programme .btn {
		display: flex;
		justify-content: center;
		margin-top: 3rem;
		padding-bottom: 2rem;
	}

	.programme .btn button {
		width: 12rem;
		height: 2rem;
		color: #fff;
		font-size: 0.85rem;
		border-radius: 1rem;
		border: 0;
		background: #F1452F;
	}

	.block {
		width: 12.5rem;
		padding: 2rem;
		font-size: 1rem;
	}

	.block>div {
		margin: auto;
		text-align: center;
	}

	.block .van-field {
		border: 1px solid #999;
		margin-top: 30px;
		border-radius: 5px;
	}
</style>



// WEBPACK FOOTER //
// src/components/programme/programme.vue